import Async from "components/DesignSystem/AsyncComponents/Async";
import { useGetSpocUnavailableGroupIdsQuery } from "store/apis/group";
import { Channel, ChannelFilters } from "stream-chat";
import { DefaultStreamChatGenerics } from "stream-chat-react/dist/types/types";
import { SpocUnrepliedView } from "./SpocUnrepliedView";
import { UnrepliedView } from "./UnrepliedView";
import { useRoleBasedView } from "hooks/useRoleBasedView";

export const UnrepliedTabView = ({
  onSelectCallback,
  filters,
  sort,
  unreplied,
  onChannelUpdated,
}: {
  onSelectCallback: (channelId?: string, messageId?: string) => void;
  filters: ChannelFilters<DefaultStreamChatGenerics>;
  sort: any;
  unreplied: boolean;
  onChannelUpdated: (
    setChannels: React.Dispatch<
      React.SetStateAction<Array<Channel<DefaultStreamChatGenerics>>>
    >
  ) => void;
}) => {
  const { isAdmin } = useRoleBasedView();
  const { data, isLoading, isSuccess, isError } =
    useGetSpocUnavailableGroupIdsQuery(undefined, { skip: !isAdmin });

  return (
    <Async.Root
      isLoading={isLoading}
      isSuccess={isSuccess}
      isEmpty={false}
      isError={isError}
    >
      <Async.Empty>
        <></>
      </Async.Empty>
      <Async.Success>
        <SpocUnrepliedView
          filters={filters}
          sort={sort}
          onSelectCallback={onSelectCallback}
          unreplied={unreplied}
          spocUnavailableGroups={data || []}
          onChannelUpdated={onChannelUpdated}
        />
        <UnrepliedView
          filters={filters}
          sort={sort}
          onSelectCallback={onSelectCallback}
          unreplied={unreplied}
          spocUnavailableGroups={data || []}
          onChannelUpdated={onChannelUpdated}
        />
      </Async.Success>
    </Async.Root>
  );
};
